export default __webpack_public_path__ + "static/media/tactrl_logo.db833ad7.svg";